import{h as t,s as a}from"./chunk-S4QFFF6M.js";import{m as r}from"./chunk-HBP5N4FR.js";r();a();function u(s,o){return s.reduce((i,{status:e,hash:n})=>(n!=null&&!o.includes(n)&&t(e)&&i.push({hash:n,previousStatus:e}),i),[])}export{u as a};
//# sourceMappingURL=chunk-2SRWYSCH.js.map
